import { useState, useEffect, useRef } from 'react';

/**
 * Custom hook to extract and manage content from assistant messages
 * Common logic shared across all split view components
 */
const useAssistantContent = (conversation, isStreaming, streamingContent, taskId) => {
  const contentRef = useRef('');
  const [latestContent, setLatestContent] = useState('');

  // Check if this is a conversation for the specified task
  const isMatchingConversation = conversation && (
    conversation.taskId === taskId ||
    // Handle common mappings
    (taskId === 'version-control' && conversation.taskId === 'git-guidelines') ||
    (taskId === 'git-guidelines' && conversation.taskId === 'version-control')
  );

  // Extract content from the latest assistant message or streaming content
  useEffect(() => {
    if (!isMatchingConversation) {
      setLatestContent('');
      contentRef.current = '';
      return;
    }

    // Get all messages (both user and assistant) to capture the full conversation context
    const allMessages = conversation?.messages || [];
    const assistantMessages = allMessages.filter(msg => msg.role === 'assistant');
    
    console.log(`${taskId} - Total messages found:`, allMessages.length);
    console.log(`${taskId} - Assistant messages found:`, assistantMessages.length);

    // Get only the latest assistant message
    const latestMessage = assistantMessages.length > 0
      ? assistantMessages[assistantMessages.length - 1].content
      : '';

    console.log(`${taskId} - Latest message length:`, latestMessage.length);

    // Use the streaming content if available, otherwise use the latest message
    const content = isStreaming && streamingContent ? streamingContent : latestMessage;
    
    console.log(`${taskId} - Final content length:`, content.length);

    // Store the content for export and other operations
    contentRef.current = content;
    setLatestContent(content);
    
  }, [conversation, isStreaming, streamingContent, isMatchingConversation, taskId]);

  // Check if we have content to display
  const hasContent = contentRef.current && contentRef.current.trim().length > 0;

  return {
    content: latestContent,
    contentRef,
    hasContent,
    isMatchingConversation
  };
};

export default useAssistantContent;